import React, { useState, useRef, useEffect } from 'react';

const CustomDropdown = ({ 
  name, 
  value, 
  onChange, 
  options, 
  placeholder = "Select an option" 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Find the selected option's label
  const selectedOption = options.find(option => option.value === value);
  const displayText = selectedOption ? selectedOption.label : placeholder;

  // Handle clicking outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle option selection
  const handleSelect = (option) => {
    onChange({ target: { name, value: option.value } });
    setIsOpen(false);
  };

  // Toggle dropdown
  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <div 
      className="position-relative" 
      ref={dropdownRef}
      style={{ width: '100%' }}
    >
      {/* Dropdown header/display - styled as Bootstrap form-select */}
      <div 
        onClick={toggleDropdown}
        style={{
          height: '44px',
          border: '1px solid #E2E8F0',
          backgroundColor: '#FFFFFF',
          borderRadius: '0.25rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0.375rem 0.75rem',
          cursor: 'pointer',
          color: value ? '#000' : '#6c757d',
          appearance: 'none',
          backgroundRepeat: 'no-repeat',
          paddingRight: '2.25rem',
          backgroundPosition: 'right 0.75rem center',
          backgroundSize: '16px 12px',
          backgroundImage: "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\")"
        }}
      >
        <span>{displayText}</span>
      </div>
      
      {/* Dropdown options */}
      {isOpen && (
        <div 
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 1000,
            backgroundColor: '#fff',
            border: '1px solid #E2E8F0',
            borderRadius: '0.25rem',
            marginTop: '4px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            maxHeight: '300px',
            overflowY: 'auto',
            padding: '8px'
          }}
        >
          {options.map((option, index) => (
            <div
              key={index}
              onClick={() => handleSelect(option)}
              style={{
                backgroundColor: '#6366F1', // Purple background
                color: 'white',
                borderRadius: '5px',
                padding: '10px',
                cursor: 'pointer',
                marginBottom: index < options.length - 1 ? '8px' : '0',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => {e.currentTarget.style.backgroundColor = '#4F46E5'}}
              onMouseOut={(e) => {e.currentTarget.style.backgroundColor = '#6366F1'}}
            >
              <div>{option.label}</div>
              {option.description && (
                <div style={{ 
                  fontSize: '0.85em',
                  marginTop: '2px'
                }}>
                  {option.description}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;